import { FinalAnswers } from "~/form/flow-machine";
import { Mietspiegeljahr } from "~/mietspiegel/types";

export const vertragsdatumToMietspiegelJahrMapping = {
  "<2015": undefined,
  "2015-2016": "2015",
  "2016-2018": "2017",
  "2018-2020": "2019",
  "2020-2022": "2021",
  "2022-2024": "2023",
  "2024-2026": "2024",
  ">2026": "2026",
} satisfies Record<
  NonNullable<FinalAnswers["Vertragsdatum"]>,
  Mietspiegeljahr | undefined
>;

/** Allowed persisted `vertragsdatum` strings (same keys as the mapping). */
export const VERTRAGSDATUM_KEYS = new Set(
  Object.keys(vertragsdatumToMietspiegelJahrMapping),
);
